// Where a tournament match falls within its day: morning before afternoon,
// then tee time, then the order it was entered — the order the leaderboard
// reads a player's rounds in (compareMatchOrder in services/sessionTeeTimes.js).
// A session split across courses is several matches, and the second course of
// a morning can be entered after the afternoon, so entry order alone won't do.

export interface MatchKey {
  am_pm?: string | null;
  tee_time?: string | null;
  round_id: number;
}

// "08:07 AM" / "1:55 PM" / "13:20" → minutes after midnight; null when unreadable.
export function teeTimeMinutes(text?: string | null): number | null {
  const m = /^\s*(\d{1,2}):(\d{2})\s*([AaPp][Mm])?\s*$/.exec(String(text || ''));
  if (!m) return null;
  let h = Number(m[1]);
  const ap = m[3] ? m[3].toUpperCase() : null;
  if (ap === 'PM' && h < 12) h += 12;
  if (ap === 'AM' && h === 12) h = 0;
  return h * 60 + Number(m[2]);
}

// A match with no session sits between the morning and the afternoon.
const sessionRank = (m: MatchKey) => (m.am_pm === 'AM' ? 0 : m.am_pm === 'PM' ? 2 : 1);
const teeRank = (m: MatchKey) => teeTimeMinutes(m.tee_time) ?? 24 * 60;

export function compareMatchesInDay(a: MatchKey, b: MatchKey): number {
  return sessionRank(a) - sessionRank(b) || teeRank(a) - teeRank(b) || a.round_id - b.round_id;
}
